module.exports = __webpack_public_path__ + "img/zalo-icon.b587d21.svg";